export enum SensorTypeEnum {
  INOUT = 'INOUT',
  PASS = 'PASS',
}